import en from './l-en'
import de from './l-de'

const languages = {
    en,
    de
};

let defaultLanguage = window.navigator.language === 'en' ? 'en' : 'de';

window.i18nData = languages[defaultLanguage];

window.i18n = (key) => {
    console.log("window.i18n", key)
    return window.i18nData[key];
}

window.changeLanguage = (lang) => {
    window.i18nData = languages[lang];
}